import React from "react";
import {DeserializedRules} from "../../slate/Transformation";
import {Rules as CodeRules} from "./code";
import {Rules as SpanRules} from "./span";
import {Rules as HeaderRules} from "./headers";
import {Rules as DivRules} from "./div";
import {Rules as CenterRules} from "./center";
import {Rules as ParagraphRules} from "./p";
import {Rules as BlockquoteRules} from "./blockquote";
import {Rules as LinkRules} from "../booq/link";
import {Rules as VideoRules} from "../booq/video";
import {Rules as PollRules} from "../booq/Poll";
import {Rules as OptInFormRules} from "../booq/OptInForm";
import {Rules as FigureRules} from "../booq/figure";
import {Rules as ComponentRules} from "../booq/component";
import {Rules as BreakLineRules} from "./br";
import {Rules as BoldRules} from "./bold";
import {Rules as ItalicRules} from "./italic";
import {Rules as EmphasizedRules} from "./emphasized";
import {Rules as UnderlineRules} from "./underline";
import {Rules as UlRules} from "./ul";
import {Rules as OlRules} from "./ol";
import {Rules as LiRules} from "./li";
import {Rules as StrikeRules} from "./strike";
import {Rules as HtmlRules} from "./html";
import {Rules as HeadRules} from "./head";
import {Rules as BodyRules} from "./body";
import {Rules as TextRules} from "./text";
import {Rules as ARules} from "./a";
import {PureElementRule} from "../../slate/html/Html";

const Elements: DeserializedRules<HTMLElement> = {
    elements: {
        "copy": PureElementRule('copy'),
        "deck": PureElementRule('deck'),
        "inline-css": PureElementRule('inline-css', {
            render: ({node}) => {
                return <div {...node.attributes} style={{display: 'none'}}>
                    {node.children}
                </div>
            }
        }),

        ...LinkRules,
        ...VideoRules,
        ...PollRules,
        ...OptInFormRules,
        ...FigureRules,
        ...ComponentRules,

        ...HtmlRules,
        ...HeadRules,
        ...BodyRules,
        ...CodeRules,
        ...SpanRules,
        ...ARules,
        ...HeaderRules,
        ...DivRules,
        ...UlRules,
        ...OlRules,
        ...LiRules,
        ...CenterRules,
        ...ParagraphRules,
        ...BlockquoteRules,
        ...BreakLineRules
    },
    leaves: {
        // font styles
        ...BoldRules,
        ...ItalicRules,
        ...EmphasizedRules,
        ...UnderlineRules,
        ...StrikeRules,
        //PureLeafRule('span'),
        // leaf text node
        ...TextRules,
    }
};

export default Elements;